module.exports = __webpack_public_path__ + "img/w52b.141357c2.jpg";